/* @ngInject */
export default function ($scope, LayoutService, toastr, Upload, AuthService, Quoting, PreferencesService, $window) {
	AuthService.redirectIfUnauthorized('view-quoting', 'splash.home');

	LayoutService.setTitle('Public Holidays');

	const uploadButton = LayoutService.getPageHeader()
	                                  .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-upload"></i> Upload Public Holidays</button>');

	const downloadButton = LayoutService.getPageHeader()
	                                    .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-download"></i> Download Public Holidays</button>');

	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       'staff.quoting.root',
			             displayName: 'Quotes',
		             },
		             {
			             route:       'staff.quoting.publicHolidays',
			             displayName: 'Public Holidays',
		             },
	             ]);

	$scope.file         = null;
	$scope.progress     = 0;
	$scope.showProgress = false;

	$scope.dateTimeFormat = PreferencesService.getDateTimePreference();

	$scope.upload = () => {
		if ($scope.file !== null) {
			$scope.progress     = 0;
			$scope.showProgress = true;

			toastr.clear();
			toastr.info('Your file is uploading now, please wait for it to complete.', 'Uploading...');

			Quoting.uploadPublicHolidays($scope.file)
			       .then((data) => {
				       $scope.progress     = 0;
				       $scope.showProgress = false;

				       toastr.clear();

				       toastr.success('Your file was uploaded successfully.', 'Success');
			       }, (response) => {
				       $scope.progress     = 0;
				       $scope.showProgress = false;

				       toastr.clear();
				       toastr.error('Your file failed to upload, please review the file and try again. The error was: ' + response.data.message, 'Error');
			       }, (data) => {
				       $scope.progress = parseInt(100.0 * data.loaded / data.total);
			       });
		} else {
			toastr.clear();
			toastr.warning('You must select a file to upload.');
		}
	};

	LayoutService.getPageHeader()
	             .onClicked(downloadButton, () => {
		             $window.open(Quoting.getDownloadURLForPublicHolidays(), '_blank');
	             });

	LayoutService.getPageHeader()
	             .onClicked(uploadButton, $scope.upload);
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/quoting/publicHolidays/controller.js